import {
  LoginWrapper,
  LoginDisplayer,
  LoginFormWrapper,
  FormSeparator,
  NavigateParagraph,
  RegisterLink,
  LoginButton,
  AnimatedBackground,
} from "./Styles";

import MikeLogo from "../../Assets/logo.png";
import WhatsAppIcon from "../../Assets/whatsapp.png";
import { FcGoogle } from "react-icons/fc";
import { FaLinkedin, FaRegUserCircle } from "react-icons/fa";
import { TbLock } from "react-icons/tb";
import { HiArrowRight } from "react-icons/hi2";

import { Button } from "../../Components/Button";
import { Input } from "../../Components/Input";
import { AgentLogin } from "./Components/AgentLogin";
import { RotatingLoaderIcon } from "../../Components/Button/Styles";

import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../Common/Hooks/useAuth";
import { isErr } from "../../Common/Utils/Result";
import { validateEmail } from "../../Common/Utils/Validators";
import { eventBus } from "../../Common/EventBus";
import { Notification } from "../../Components/Notifications";
import { ResetPasswordRequest } from "../ResetPasswordRequest";

export const Login = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [isAgent, setIsAgent] = useState(false);
  const [view, setView] = useState("login");

  const {
    loginWithPassword,
    loginWithGoogle,
    loginWithLinkedin,
    redirectPostLoginSso,
  } = useAuth();
  const navigate = useNavigate();

  const onSubmit = async () => {
    if (!email || !password) {
      eventBus.emit(
        "NOTIFICATION",
        Notification.buildNotification(
          "error",
          t("auth.login.errors.missingFields")
        )
      );
      return;
    }
    if (!validateEmail(email)) {
      eventBus.emit(
        "NOTIFICATION",
        Notification.buildNotification(
          "error",
          t("auth.login.errors.invalidEmail")
        )
      );
      return;
    }
    setLoading(true);
    const response = await loginWithPassword(email, password);
    setLoading(false);
    if (isErr(response)) {
      eventBus.emit(
        "NOTIFICATION",
        Notification.buildNotification("error", t("auth.login.errors.loginFailed"))
      );
      return;
    }
    navigate("/");
  };

  const onLoginWithGoogle = async () => {
    loginWithGoogle();
  };

  const onLoginWithLinkedin = async () => {
    loginWithLinkedin();
  };

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);

    const providerQuery = queryParams.get("callback_provider");

    if (providerQuery === null) {
      return;
    }

    redirectPostLoginSso();
  }, [redirectPostLoginSso]);

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") {
      onSubmit();
    }
  };


  const renderContent = () => {
    switch (view) {
      case "resetPasswordRequest":
        return (
          <ResetPasswordRequest
            backCallback={() => setView("login")}
            backToLoginCallback={() => setView("login")}
          />
        );
      default:
        return (
          <LoginFormWrapper>
            <Button onClick={() => setIsAgent(true)}>
              <img src={WhatsAppIcon} alt={t("auth.login.whatsappLogoAlt")} height={15} style={{ marginRight: "0.5rem" }} />
              {t("auth.login.whatsappButton")}
            </Button>
            <Button onClick={onLoginWithGoogle}>
              <FcGoogle /> {t("auth.login.googleButton")}
            </Button>
            <Button onClick={onLoginWithLinkedin}>
              <FaLinkedin /> {t("auth.login.linkedinButton")}
            </Button>
            <FormSeparator>{t("auth.login.orSeparator")}</FormSeparator>
            <Input
              Icon={FaRegUserCircle}
              placeholder={t("auth.login.emailPlaceholder")}
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              onKeyPress={handleKeyPress}
            />
            <Input
              Icon={TbLock}
              placeholder={t("auth.login.passwordPlaceholder")}
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              onKeyPress={handleKeyPress}
            />
            <LoginButton onClick={onSubmit} disabled={loading} $isLoading={loading}>
              {loading && <RotatingLoaderIcon />}
              {loading ? t("auth.login.submitButtonLoading") : (
                <>
                  <span>{t("auth.login.submitButton")}</span>
                  <HiArrowRight />
                </>
              )}
            </LoginButton>
            <NavigateParagraph>
              {t("auth.login.noAccount")}{" "}
              <RegisterLink onClick={() => navigate("/register")}>{t("auth.login.registerLink")}</RegisterLink>
            </NavigateParagraph>
            <NavigateParagraph>
              <b onClick={() => setView("resetPasswordRequest")}>
                {t("auth.login.forgotPassword")}
              </b>
            </NavigateParagraph>
          </LoginFormWrapper>
        );
    }
  };

  return (
    <>
      <LoginWrapper>
        <AnimatedBackground>
          <div className="blob blob-1"></div>
          <div className="blob blob-2"></div>
          <div className="blob blob-3"></div>
        </AnimatedBackground>
        <img src={MikeLogo} alt={t("auth.login.mikeLogoAlt")} />
        <LoginDisplayer>{renderContent()}</LoginDisplayer>
      </LoginWrapper>
      <AgentLogin display={isAgent} onClose={() => setIsAgent(false)} />
    </>
  );
};
